module.exports = __webpack_public_path__ + "img/guide3_pc.a31a9e31.jpg";